module.exports = __webpack_public_path__ + "img/competition.a92d6bf7.png";